export const companySearchEn = {
  companySearch: {
    search: {
      location: 'Location',
      name: 'Company Name',
      id: 'Member ID',
      country: 'Country/Region',
      city: 'City',
      port: 'Port',
      allCounties: 'All Countries/Regions',
      allCities: 'All Cities',
      companyName: 'Please enter the company name',
      memberID: 'Please enter the member ID',
      allPorts: 'All ports',
      noData: 'No Results, Please try again',
      loading: 'loading',
      selectCountry: 'Select Countries or Regions',
      selectCity: 'Select Cities',
      selectPort: 'Select Port',
    },
  },
}
export const companySearchCn = {
  companySearch: {
    search: {
      location: '所在地',
      name: '公司名称',
      id: '会员ID',
      country: '国家/区域',
      city: '城市',
      port: '港口',
      allCounties: '所有国家/区域',
      allCities: '所有城市',
      companyName: '请填写公司名称',
      memberID: '请填写会员ID',
      allPorts: '所有港口',
      noData: '暂无结果，请重新尝试',
      loading: 'loading',
      selectCountry: '选定国家/区域',
      selectCity: '选定城市',
      selectPort: '选定港口',
    },
  },
}
